// #region imports

import * as React from 'react';

// Material-UI
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MyRequestsHelp from './MyRequestsHelp';

// #endregion

// #region interfaces

interface MyRequestsHelpDialogProps {
  handleClose: () => void;
  show: boolean;
}

// #endregion


const MyRequestsHelpDialog: React.FC<MyRequestsHelpDialogProps> = (props) => {

  return (
    <Dialog
      open={props.show}
      onClose={props.handleClose}
    >
      <DialogTitle>Lodge Use Requests Help</DialogTitle>
      <DialogContent>
        <MyRequestsHelp />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.handleClose()} color="primary">Close</Button>
      </DialogActions>
    </Dialog>
  );

}

export default MyRequestsHelpDialog;